import { useContext, useEffect } from "react";
import { UserContext } from "../../../context/UserContext";
import { IconButton } from "@mui/material";
import { trackEventMatomo } from "../../../helpers/matomo";
import CancelIcon from '@mui/icons-material/Cancel';
import SingleNotification from "../SingleNotification";

export default function ModalTicket({ id, setId }: { id?: string | null, setId?: Function }) {

  const { setShow, show } = useContext(UserContext);

  useEffect(() => {
    console.log(id);
  }
    , []);

  return (
    <>
      <div className={`modal ${show ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-card" style={{ width: '850px' }}>
          <header className="modal-card-head" style={{ justifyContent: 'flex-end' }}>
            <IconButton>
              <CancelIcon
                color='error'
                onClick={() => {
                  trackEventMatomo('modal chamado', 'click', 'button', 'fecha/cancela');
                  setShow(false);
                  setId && setId(null);
                }}
              />
            </IconButton>
          </header>
          <section className="modal-card-body" style={{ paddingLeft: '30px', paddingRight: '30px', overflowY: 'scroll' }}>
            <SingleNotification idModal={id as string} />
          </section>
        </div>
      </div >
    </>
  );
}
